module.exports = __webpack_public_path__ + "img/03.8b3ad12c.jpg";